<template>
    <div :class="`base-card rounded-2xl bg-white ${props.noPadding ? '' : 'px-12 py-10'}`">
        <p v-if="props.title" class="mb-5 h-6 text-base font-bold text-black">{{props.title}}</p>
        <slot v-else name="title"></slot>
        <slot></slot>
    </div>
</template>

<script setup lang="ts">

const props = withDefaults(defineProps<{
    title?: string
    noPadding?: boolean
}>(), {
    title: '',
    noPadding: false,
})
</script>
<style>
.base-card {
    box-shadow: 0px 3px 8px rgba(0, 81, 252, 0.14), 0px 0px 4px rgba(0, 81, 252, 0.08);
}
</style>
